'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/has/~/function-bind/index.js
// module id = 289
// module chunks = 87